import React from 'react';
import { gql, useQuery } from '@apollo/client';
import Skeleton from '@material-ui/lab/Skeleton/Skeleton';
import { makeStyles } from '@material-ui/core/styles';

const SERVICE_REQUEST_ADDRESS_QUERY = gql`
query GetAddress($requestId: Int!) {
  readRequest(requestId:$requestId) {
    id
    moduleLinks {
      moduleLinkRoleTypeDescription
      moduleLinkDescription
    }
  }
}
`;
interface ModuleLinkResult {
  moduleLinkRoleTypeDescription: string
  moduleLinkDescription: string
}
interface ReadRequestData {
  id: string
  moduleLinks: ModuleLinkResult[]
}
interface QueryData {
  readRequest: ReadRequestData
}
interface QueryVars {
  requestId: number
}
interface Props {
  requestId: number
}
const JobDataTableRowAddress = ({requestId}:Props) => {
  const classes = useStyles();
  const { loading, data } = useQuery<QueryData, QueryVars>( SERVICE_REQUEST_ADDRESS_QUERY, { 
    variables: { requestId },
    notifyOnNetworkStatusChange: true,
  });
  const [ addressText, setAddressText ] = React.useState<string>('');
  React.useEffect(()=>{
    if(data) {
      data.readRequest.moduleLinks.forEach( (moduleLink) => {
        if(moduleLink.moduleLinkRoleTypeDescription === 'Incident Address') {
          setAddressText(moduleLink.moduleLinkDescription);
        }
      });
    }
  }, [data]);

  if(loading)       {return (<Skeleton component="div" variant="text" className={classes.addressSkeleton} />)}
  
  return (
    <div className="addressText">{addressText}</div>
  );
}

const useStyles = makeStyles(() => ({
  addressSkeleton: {
    height: "16px",
  },
}));


export default JobDataTableRowAddress;
